export default "__VITE_ASSET__34LRy5H5__"